import { ListItemIcon, MenuItem, Typography } from '@mui/material';
import { FC } from 'react';
import { MenuItemStyle, iconStyles } from './useStyles';

interface MenuItemDdlProps {
  label: string;
  icon: JSX.Element;
  onClickFunc?: () => void;
}
const MenuItemDdl: FC<MenuItemDdlProps> = ({ label, icon, onClickFunc }) => {
  return (
    <MenuItem onClick={onClickFunc} sx={MenuItemStyle} tabIndex={0}>
      {icon && <ListItemIcon sx={iconStyles}>{icon}</ListItemIcon>}
      <Typography variant="h4">{label}</Typography>
    </MenuItem>
  );
};

export default MenuItemDdl;
